import { Button } from '@mui/material'
import React from 'react'
import { StyledGrid } from './styles'

interface Props {
    disabled: boolean
    onClickHandler: React.MouseEventHandler<HTMLButtonElement> | undefined
    title: string
    style?: React.CSSProperties // Optional style prop
}

const TertiaryButton: React.FC<Props> = ({
    disabled,
    onClickHandler,
    title,
    style,
}: Props) => {
    return (
        <StyledGrid style={style}>
            <Button
                data-testid="tert-btn"
                disabled={disabled}
                onClick={onClickHandler}
            >
                {title}
            </Button>
        </StyledGrid>
    )
}

export default TertiaryButton
